import memoize from 'lru-memoize';
import { createValidator, required, email } from 'utils/validation';

// @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
const emailValdiation = createValidator({
  email: [email, required],
});
export default memoize(10)(emailValdiation);
